import { apiSlice } from "../api/apiSlice";

export const teamsApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getTeamsData: builder.query({
            query: () => "/teams",
            providesTags: ["Teams"],
        }),
        addTeams: builder.mutation({
            query: (data) => ({
                url: "/teams",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Teams"],
        }),
        getTeam: builder.query({
            query: (id) => ({
                url: `/teams/${id}`,
            }),
            keepUnusedDataFor: 1,
        }),
        addMember: builder.mutation({
            query: ({ id, data }) => ({
                url: `/teams/${id}`,
                method: "PATCH",
                body: data,
            }),
            invalidatesTags: ["Teams"],
        }),
    }),
});

export const {
    useGetTeamsDataQuery,
    useAddTeamsMutation,
    useGetTeamQuery,
    useAddMemberMutation,
} = teamsApi;
